<template>
	<button
		class="mention-option at-everyone"
		data-user="everyone"
		:data-fullname="$t('model_mentions_moniker_everyone').substring(1)"
		data-me="true"
	>
		<div class="mention-avatar">
			<EveryoneIcon />
		</div>
		<span>{{ $t('model_mentions_moniker_everyone') }}</span>
		<span class="info">{{
			$t(
				isThread
					? 'model_mentions_moniker_everyone_description_thread'
					: 'model_mentions_moniker_everyone_description'
			)
		}}</span>
	</button>
</template>

<script>
import { EveryoneIcon } from '@/icons'

export default {
	components: { EveryoneIcon },
	props: {
		isThread: { type: Boolean, default: false },
	},
}
</script>
<style lang="scss" scoped>
$highlight: #f3f3f3;
.mention-option {
	cursor: pointer;
	display: flex;
	align-items: center;
	padding: 8px;
	margin: 0 4px 4px 0;
	width: 100%;
	background: white;
	border: none;
	border-radius: 12px;
	font-family: Avenir-Roman;
	font-size: 17px;
	&.mention-active {
		background: $highlight;
	}
	span {
		margin-left: 12px;
		&.info {
			font-size: 14px;
			color: #bdbcbc;
		}
	}
}
</style>
